import pixAxios from '@/axios/pixAxios.js';
import regexConst from '@/consts/regex.const.js';
import appIdParameter from '@/consts/appIdParameterConfig.const.js';
import pixNumeral from '@/services/common/pixNumeral.utils.js';
import { evaluate } from 'mathjs';
import store from '@/store';
import _ from 'lodash';

const numeral = require('numeral');

export default {
  /**
   * Transforms the TableFeatures data into a structure that can read the generic table.
   */
  getGenericTableDataFromModel(internalField, model) {
    return model?.TableFeatures?.find(({ Name }) => Name === internalField)?.TableData?.map((row) => row.reduce((pv, { InternalName, Value }) => ({ ...pv, [InternalName]: Value }), {})) ?? [];
  },

  /**
   * Transforms the generic table data into the structure that is stored in TableFeatures.
   */
  setGenericTableDataIntoModel(internalField, model, data, tableConfig) {
    if (!model.TableFeatures) model.TableFeatures = [];
    if (!model.TableFeatures.find(({ Name }) => Name === internalField)) model.TableFeatures.push({ Name: internalField, TableData: [] });
    const tableEl = model.TableFeatures.find(({ Name }) => Name === internalField);

    // Obtain the fields to be filled in the rows and mark the empty rows to IsDeleted
    const fields = Object.keys(
      tableConfig?.filter(({ FieldControlType, CellType }) => FieldControlType !== 'headerbutton' && FieldControlType !== 'section' && CellType !== 'LinkType').reduce((pv, { InternalField }) => ({ ...pv, [InternalField]: null }), {})
    );

    let dateFilter = data.map((row) => {
      return { ...row, IsDeleted: !fields.map((field) => row[field]).some((value) => value !== null) };
    });

    tableEl.TableData = dateFilter
      .filter(({ IsDeleted }) => !IsDeleted)
      .map((row) =>
        Object.keys(row)
          .filter((att) => tableConfig.some(({ InternalField }) => InternalField === att))
          .map((att) => this.getTableFeaturesAttributes(att, row, tableConfig))
      );
  },

  // TODO Comprobar si son necesarios estos campos.
  // "Description": "Tenant Address",
  // "Label": "Tenant Address",
  getTableFeaturesAttributes(att, row, cols) {
    const { FieldDataType } = cols.find(({ InternalField }) => InternalField === att);
    return { InternalName: att, Value: row[att], FeatureDataType: this.getFeatureDataType(FieldDataType) };
  },

  getFeatureDataType(fieldDataType) {
    if (fieldDataType === 'string') return 'text';
    return fieldDataType;
  },

  getReadTransform(value, transform) {
    // This transformation is done from the cell type components, which dont know the context of the model they are operating with
    // so genericFormService.getTransformedComputedOperation cannot be used because they dont have a prop with the complete model
    // from where to get related fields.
    // Thus, readTransforms inside genericTables are limited to operating with "this" field
    if (value && !Number.isNaN(value) && value !== '' && transform) {
      return evaluate(transform.replace('this', value));
    }
  },

  getFormatAndSuffix(currency, area, frequency, precedent, value, format) {
    let replacedValue;

    const replaceWith = {
      c: currency,
      a: area,
      f: frequency,
      p: precedent,
    };

    if (format) {
      replacedValue = format.replace(regexConst.NUMERAL, (match) => {
        return pixNumeral.getNumeralFormat(value, match);
      });
    }

    if (replacedValue !== null && replacedValue !== undefined && replacedValue !== '' && replacedValue !== 'Infinity' && replacedValue !== Infinity) {
      replacedValue = replacedValue.replace(regexConst.METRIC, (match) => {
        return replaceWith[match];
      });
    }

    return replacedValue;
  },

  getGenericTableCall(formId, forceCall = false, { fullInstance: instance } = store.getters, { langCode } = store.getters, { appId = appIdParameter.PIX } = store.getters) {
    const params = {
      appId,
      formId,
      instance: instance ?? store.getters['authModule/fullInstance'],
      langCode,
    };

    const table = store.getters['genericConfigModule/getGenericTableConfigById'](formId);

    return !forceCall && table
      ? Promise.resolve(_.cloneDeep(table))
      : pixAxios.post('/api/GenericConfig/GetTable', params).then(({ data }) => {
          const tableConfig = data?.map((config) => ({ ...config, sort: 'NOS' }));
          store.dispatch('genericConfigModule/setGenericTableConfig', { genericTableConfig: _.cloneDeep(tableConfig), formId });
          return tableConfig;
        });
  },
};
